"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Romer = /** @class */ (function () {
    function Romer() {
    }
    Romer.toCelcius = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (romer - 7.5) * 40 / 21;
    };
    Romer.toFahrenheit = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (romer - 7.5) * 24 / 7 + 32;
    };
    Romer.toKelvin = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (romer - 7.5) * 40 / 21 + 273.15;
    };
    Romer.toReamur = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (romer - 7.5) * 32 / 21;
    };
    Romer.toNewton = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (romer - 7.5) * 22 / 35;
    };
    Romer.toRankine = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (romer - 7.5) * 24 / 7 + 491.67;
    };
    Romer.toDelisle = function (romer) {
        if (romer === void 0) { romer = 1; }
        return (60 - romer) * 20 / 7;
    };
    Romer.unit = {
        name: 'Rømer',
        code: '°Rø'
    };
    return Romer;
}());
exports.Romer = Romer;
